import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import resourcesToBackend from 'i18next-resources-to-backend';

const LANGUAGE_SETS = ['en', 'zh-Hant', 'ja'];

let defaultLanguage = localStorage.getItem('language') ?? '';

if (!LANGUAGE_SETS.includes(defaultLanguage)) {
  defaultLanguage = 'en';
}

const backend = {
  backends: [
    HttpBackend,
    resourcesToBackend((lng, ns, clb) => {
      import(`../public/locales/${lng}/${ns}.json`)
        .then((resources) => clb(null, resources))
        // @ts-ignore
        .catch(clb);
    }),
  ],
  backendOptions: [
    {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  ],
};

i18n
  .use(initReactI18next)
  .use(ChainedBackend)
  .init({
    backend,
    supportedLngs: LANGUAGE_SETS,
    lng: defaultLanguage,
    ns: ['common'],
    fallbackLng: 'en',
    defaultNS: 'common',
    fallbackNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: 'languageChanged editorSaved',
    },
  });

export const changeDefaultLanguage = (lang: string) => {
  localStorage.setItem('language', lang);
};

export const toBCP47 = (code: string) => {
  switch (code) {
    case 'en':
      return 'en-US';
    case 'zh-Hant':
    case 'zh-hant':
      return 'zh-TW';
    case 'ja':
      return 'ja-JP';
    default:
      return code;
  }
};

export default i18n;
